import { render, staticRenderFns } from "./Printparcelinformation.vue?vue&type=template&id=3c069a5c&scoped=true&"
import script from "./Printparcelinformation.vue?vue&type=script&lang=js&"
export * from "./Printparcelinformation.vue?vue&type=script&lang=js&"
import style0 from "./Printparcelinformation.vue?vue&type=style&index=0&id=3c069a5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c069a5c",
  null
  
)

export default component.exports